import React, { useState } from 'react'
import './settings.css';
import Tabs from './taps/Tabs'
import { Grid } from '@mui/material';
const Settings = ({setShowProgress,showprogress,authenticateToken,setMessage,setOpenSnackBar,handlepostMessage,handleUpdateOrder}) => {
  const [user,setUser]=useState({});
     const [products,setProducts]= useState([]);
     const [stores,setStores]=useState([]);
     const [categories,setCategories]=useState([])
     const [groupCategories,setGroupCategories]=useState([])
     const [transactions,setTransactions]=useState([])
  React.useEffect(()=>{
     try{
      setUser(JSON.parse(localStorage.getItem('user')).user)
     }catch(err){
      console.log(err)
     }
  }, [setUser])
  return (
    <Grid container justifyContent='space-between' >
       <Grid item xs={12} padding={2}>
        <h1 className="SettingsTitle">Settings</h1>
        
       </Grid>
     <Grid item xs={12}  >
       {
      user ? <Grid container justifyContent='space-between' >
         <Grid item >
               <Tabs products={products} setProducts={setProducts} stores={stores} setStores={setStores} user={user} setUser={setUser} categories={categories} setCategories={setCategories} groupCategories={groupCategories} setGroupCategories={setGroupCategories} transactions={transactions} setTransactions={setTransactions} className='tabs' setShowProgress={setShowProgress} showprogress={showprogress}authenticateToken={authenticateToken} setMessage={setMessage}setOpenSnackBar={setOpenSnackBar} handlepostMessage={handlepostMessage} handleUpdateOrder={handleUpdateOrder}/>
         </Grid>
      </Grid>:'please login to proceed'
    }
     </Grid>
    </Grid>
  )
}

export default Settings
